"use client"
import styled from "styled-components"
import Login from "../components/Login"

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 160px);
`

const LoginPage = ({ onLogin }) => {
  return (
    <PageContainer>
      <Login onLogin={onLogin} />
    </PageContainer>
  )
}

export default LoginPage

